import type { ReactNode } from 'react';

export const symbol_chromecast_device: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M840-390q-12.75 0-21.37-8.63Q810-407.25 810-420v-120q0-12.75 8.63-21.38Q827.25-570 840-570h50q12.75 0 21.38 8.62Q920-552.75 920-540v120q0 12.75-8.62 21.37Q902.75-390 890-390h-50Zm-130 70H440q-16 0-32.5 4.5T366-300q-39 17-67 23.5t-59 6.5q-78 0-139-46T40-420v-120q0-59 61-104.5T240-690q31 0 59 6.5t67 23.5q25 11 41.5 15.5T440-640h270q24.75 0 42.38 17.62Q770-604.75 770-580v200q0 24.75-17.62 42.37Q734.75-320 710-320Zm-470-10q24.06 0 47.03-5.5Q310-341 342-355q33-14 54.97-19.5T440-380h270v-200H440q-21.06 0-43.03-5.5Q375-591 342-605q-32-14-54.97-19.5T240-630q-54 0-97 27.64-43 27.65-43 62.36v45h15q6 0 10.5 4.5T130-480q0 6-4.5 10.5T115-465h-15v45q0 34.71 43 62.36Q186-330 240-330ZM100-480Z"
		/>
	</svg>
);
